import styled from "styled-components";

import * as Code from "ds/Code";

export const CodeBlock = styled(Code.Block)`
  width: 80%;
`;
